import React from 'react'

import {
  Paper,
  Divider,
  Typography,
  Button,
  makeStyles,
} from '@material-ui/core'

import * as service from 'service'
import useConfirmDialog from 'hooks/useConfirmDialog'
import styles from './styles'
import useSnackbar from 'hooks/useSnackbar'

const useStyles = makeStyles(styles)

const UserDisable = ({ userId, active: activeProp, onStatusChange }) => {
  const classes = useStyles()
  const confirmDialog = useConfirmDialog()
  const [active, setActive] = React.useState(activeProp)
  const snackbar = useSnackbar()

  const action = active ? 'Inativar' : 'Ativar'
  const message = active
    ? 'Ao inativar o usuário, ele perderá o acesso ao sistema.'
    : 'Ao ativar o usuário, ele ficará disponível novamente para o acesso.'

  const handleClickButton = () => {
    if (!active) {
      confirmDialog.open({
        title: 'Ativar usuário',
        message: 'Para prosseguir com a ativação, clique em Ativar.',
        cancelButton: 'Cancelar',
        confirmButton: 'Ativar',
        handleConfirm: async e => {
          setActive(true)
          try {
            await service.recurrence.users.put({
              userId,
              user: { active: true },
            })
            snackbar.open({
              message: 'Usuário ativado com sucesso!',
              variant: 'success',
            })
          } catch {
            snackbar.open({
              message: 'Não foi possível reativar!',
              variant: 'error',
            })
          }
          onStatusChange(true)
        },
      })

      return
    }

    confirmDialog.open({
      title: 'Inativar usuário',
      message:
        'O usuário inativo poderá ser reativado posteriormente. Para prosseguir com a inativação, clique em Inativar.',
      cancelButton: 'Cancelar',
      confirmButton: 'Inativar',
      handleConfirm: async e => {
        setActive(false)
        try {
          await service.recurrence.users.destroy({ userId })
          snackbar.open({
            message: 'Usuário inativado com sucesso!',
            variant: 'success',
          })
        } catch {
          snackbar.open({
            message: 'Não foi possível inativar!',
            variant: 'error',
          })
        }
        onStatusChange(false)
      },
    })
  }

  return (
    <Paper>
      <div className={classes.box}>
        <Typography variant="h4">{action} usuário</Typography>
      </div>

      <Divider />

      <div className={classes.box}>
        <Typography className={classes.message}>{message}</Typography>
        <Button color="primary" variant="outlined" onClick={handleClickButton}>
          {action}
        </Button>
      </div>
    </Paper>
  )
}

export default UserDisable
